import { defineComponent as _defineComponent } from 'vue'
import { OSidebar } from '@oruga-ui/oruga'


export default /*#__PURE__*/_defineComponent({
  __name: 'NeoSidebar',
  props: {
    mobile: null,
    expandOnHover: { type: Boolean },
    fullheight: { type: Boolean },
    fullwidth: { type: Boolean },
    reduce: { type: Boolean },
    open: { type: Boolean },
    right: { type: Boolean },
    overlay: { type: Boolean },
    canCancel: { type: [Array, Boolean] },
    onCancel: null,
    position: null
  },
  setup(__props: any) {



return { __sfc: true,OSidebar }
}

})